var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11747_50434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.00011V11.0001H5V20.0001H19V11.0001H16V9.00011H19C20.1046 9.00011 21 9.89554 21 11.0001V20.0001C21 21.1047 20.1046 22.0001 19 22.0001H5C3.89543 22.0001 3 21.1047 3 20.0001V11.0001C3 9.89553 3.89543 9.00011 5 9.00011H8ZM12.8839 2.46865L16.2426 5.82741C16.6332 6.21794 16.6332 6.8511 16.2426 7.24162C15.8521 7.63215 15.219 7.63215 14.8284 7.24162L13 5.4132V15.0001C13 15.5524 12.5523 16.0001 12 16.0001C11.4477 16.0001 11 15.5524 11 15.0001V5.4132L9.17157 7.24162C8.78105 7.63215 8.14788 7.63215 7.75736 7.24162C7.36684 6.8511 7.36684 6.21794 7.75736 5.82741L11.1161 2.46865C11.6043 1.9805 12.3957 1.9805 12.8839 2.46865Z",
    fill: "#09244B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11747_50434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/documentUpload.82b2d8ee246e7e72da94c158e9ea7740.svg";
export { ForwardRef as ReactComponent };